module.exports = __webpack_public_path__ + "img/login_2.4e7cc849.png";